module.exports = __webpack_public_path__ + "img/swipe1.07a90030.png";